module.exports = __webpack_public_path__ + "static/project-planning@2x.0f07199c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/guides/img/project-planning@2x.png
// module id = 823
// module chunks = 35783957827783